const getEventsLoading = (state) => {
  return state?.workOrderManagement?.eventsLoading ?? false;
};

export { getEventsLoading };
